import React, { useState } from "react";
import LaunchLogo from "../Asset/Icons/SixsLogo.svg";
import sgLogo from "../Asset/Icons/SgLogo.png";
import { Button, Typography, Grid } from "@mui/material";
import { useEffect } from "react";
import configParam from "../config";
import axios from "axios";
import debug from 'debug';
import dayjs from "dayjs";
import FeedbackForm from "../Pages/FeedbackForm/feedbackform";
import utc from 'dayjs/plugin/utc';
import AlertDialog from "../Pages/input/AlertDialog";
const log = debug('login');


//teste code
const LoginLaunchPage = () => {

  dayjs.extend(utc);

// ✅ Verify if UTC is available:
console.log(dayjs().utc ? "✅ UTC is available" : "❌ UTC not available");
  const ApiURL = configParam.API_URL;
  const access_token = JSON.parse(localStorage.getItem("accesstoken"));
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const containerStyle = {
    position: "relative",
    right: "0",
    top: "0",
    height: "100vh",
    width: "400px",
    padding: "20px",
    backgroundColor: "#fff",
  };

  // ✅ Handle SSO login
  const handleSignOn = () => {
    window.location.replace(configParam.SSO_URL); 
  };


  //test code
//   const fetchUserDetails = async (code) => {
//   setLoading(true);
//   try {
//     const response = await axios.get(`${ApiURL}/login`, {
//       params: { code },
//     });

//     const { success, UserData, access_token, err } = response.data;

//     if (success) {
//       localStorage.setItem("userDatas", JSON.stringify(UserData));
//       localStorage.setItem("accesstoken", JSON.stringify(access_token));
//       localStorage.setItem("isLoggedIn", "true");
//  console.log("📝 Fetching Feedback Eligibility...");
//       // ✅ Call the feedback condition check directly
//       const eligibilityResponse = await axios.get(`${ApiURL}/checkFeedbackEligibility`, {
//         params: { sgid: UserData.sgid },
//         headers: { Authorization: `Bearer ${access_token}` },
//       });
// console.log("eligibilityResponse",eligibilityResponse)
//       // If the form should open, show it, otherwise, go to Plant
//       if (eligibilityResponse.data.openToday) {
//         setShowFeedback(true);
//       } else {
//         setShowFeedback(false);
//         window.location.href = "/Plant";
//       }
//     } else {
//       setError(err ?? "Access denied");
//     }
//   } catch (error) {
//     console.error("Error during login:", error);
//     setError("An error occurred during login");
//   } finally {
//     setLoading(false);
//   }
// };

// const handleRemindMe = () => {
//   const userdetails = JSON.parse(localStorage.getItem("userDatas"));
//   if (!userdetails) {
//     console.error("User not found in localStorage");
//     return;
//   }

//   const today = dayjs().format("YYYY-MM-DD");
//   let remindMeData = JSON.parse(localStorage.getItem("remindMeData")) || {};

//   // If no entry exists for this user, create it
//   if (!remindMeData[userdetails.sgid]) {
//     remindMeData[userdetails.sgid] = { date: today, count: 0 };
//   }

//   const userRemindData = remindMeData[userdetails.sgid];

//   // If the date has changed, reset the count
//   if (userRemindData.date !== today) {
//     userRemindData.date = today;
//     userRemindData.count = 0;
//   }

//   // Increment the count
//   if (userRemindData.count < 2) {
//     userRemindData.count += 1;
//     localStorage.setItem("remindMeData", JSON.stringify(remindMeData));
//     alert(`You can skip ${2 - userRemindData.count} more time(s) today.`);
//     setShowFeedback(false);
//     window.location.href = "/Plant";
//   } else {
//     // Third time "Remind Me" clicked, redirect permanently to Plant
//     alert("You have reached the maximum remind-me limit for today.");
//     userRemindData.count = 3;
//     localStorage.setItem("remindMeData", JSON.stringify(remindMeData));
//     setShowFeedback(false);
//     window.location.href = "/Plant";
//   }
// };

  // ✅ Fetch user details after redirect from SSO
  const fetchUserDetails = async (code) => {
    setLoading(true);
    try {
      const response = await axios.get(`${ApiURL}/login`, {
        params: { code },
      });

      const { success, UserData, access_token, err } = response.data;

      if (success) {
        localStorage.setItem("userDatas", JSON.stringify(UserData));
        localStorage.setItem("accesstoken", JSON.stringify(access_token));
        localStorage.setItem("isLoggedIn", "true");
        // checkFeedbackCondition();
         const storedToken = JSON.parse(localStorage.getItem("accesstoken"));

      // ✅ Call the feedback condition check after token is surely set
      if (storedToken) {
        await checkFeedbackCondition(storedToken); // Pass the token directly
      }
      } else {
        setError(err ?? "Access denied");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setError("An error occurred during login");
    } finally {
      setLoading(false);
    }
  };



  const checkFeedbackCondition = async () => {
    const userdetails = JSON.parse(localStorage.getItem("userDatas"));
    const access_token = JSON.parse(localStorage.getItem("accesstoken"));
if (!userdetails) {
      console.error("User not found in localStorage");
      return;
    }

    try {

     
      const response = await axios.get(`${ApiURL}/checkFeedbackEligibility`, {
        params: { sgid: userdetails.sgid },
        headers: { Authorization: `Bearer ${access_token}` },
      });

      if (response.data.openToday) {
        // Show feedback form if it's exactly the 90th day
        setShowFeedback(true);
      } else {
        // Redirect to Plant if it's not the 90th day
        setShowFeedback(false);
        window.location.href = "/Plant";
      }
    } catch (error) {
      console.error("Error during feedback eligibility check:", error);
      // alert("There was an error checking feedback eligibility.");
    }
  };



  
  const handleSubmit = async (responses) => {
    try {
      const userdetails = JSON.parse(localStorage.getItem("userDatas"));
      const formattedFeedbackData = Object.entries(responses).map(([question, answer]) => ({
        question,
        answer,
      }));

      await axios.post(
        `${ApiURL}/createFeedback`,
        { feedbackData: formattedFeedbackData, userdetails },
        { headers: { Authorization: `Bearer ${access_token}` } }
      );

      // localStorage.setItem("lastSubmissionDate", dayjs().toISOString());
      // localStorage.removeItem("remindMeData");
      // alert("Feedback submitted successfully!");
      AlertDialog({
  type: 'success',
  title: 'Success!',
  text: 'Feedback submitted successfully!',
  confirmButtonText: 'OK',
  onConfirm: () => {
    setShowFeedback(false);
    window.location.href = "/Plant";
  }
});

      // setShowFeedback(false);
      // window.location.href = "/Plant";
    } catch (error) {
      console.error("Error during feedback submission:", error);
      // alert("There was an error submitting your feedback.");
      AlertDialog({
  type: 'error',
  title: 'Submission Failed',
  text: 'There was an error submitting your feedback.',
  confirmButtonText: 'OK',
});

    }
  };

  // ✅ Handle Remind Me logic
  const handleRemindMe = () => {
    const today = dayjs().format("YYYY-MM-DD");
    let remindMeData = JSON.parse(localStorage.getItem("remindMeData")) || { date: today, count: 0 };

    // If the date has changed, reset the count
    if (remindMeData.date !== today) {
      remindMeData = { date: today, count: 0 };
    }

    // Increment the count
    if (remindMeData.count < 2) {
      remindMeData.count += 1;
      localStorage.setItem("remindMeData", JSON.stringify(remindMeData));
      // alert(`You can skip ${2 - remindMeData.count} more time(s) today.`);
      AlertDialog({
  type: 'success',
  title: 'Reminder',
  text: `You can skip ${2 - remindMeData.count} more time(s) today.`,
  confirmButtonText: 'OK',
  onConfirm: () => {
    setShowFeedback(false);
    window.location.href = "/Plant";
  }
});

      // setShowFeedback(false);
      // window.location.href = "/Plant";
    } else {
      // alert("You have reached the maximum remind-me limit for today.");
      AlertDialog({
  type: 'error',
  title: 'Limit Reached',
  text: "You have reached the maximum remind-me limit for today.",
  confirmButtonText: 'OK',
  onConfirm: () => {
    setShowFeedback(false);
    window.location.href = "/Plant";
  }
});

      localStorage.setItem("remindMeData", JSON.stringify({ date: today, count: 3 }));
      // setShowFeedback(false);
      // window.location.href = "/Plant";
    }
  };







 


  // ✅ On Component Mount - Check for code from SSO
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const code = queryParameters.get("code");

    if (code) {
      fetchUserDetails(code);
    }
  }, []);

  return (
    <>
      {showFeedback ? (
       
         <FeedbackForm onSubmit={handleSubmit}  onRemindMe={handleRemindMe} />
      ) : (
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: window.innerWidth >= 600 ? "row" : "column",
            justifyContent: "center",
            alignItems: "center",
            background: "white",
          }}
        >
          {window.innerWidth >= 600 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
              }}
            >
              <img src={LaunchLogo} alt="Logo" className="icon" />
            </div>
          )}
          <Grid container style={{ ...containerStyle }} justifyContent="center" alignItems="center">
            <Grid
              item
              container
              direction="column"
              justifyContent="center"
              alignItems="start"
              sx={{ width: { xs: "90%", sm: "70%", md: "50%" } }}
            >
              <Grid item sx={{ alignSelf: "center" }}>
                <img src={LaunchLogo} alt="Logo" className="icon" style={{ width: "170px" }} />
              </Grid>
              <Grid item container direction="column" alignItems="center">
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#0086DC",
                    width: "100%",
                    borderRadius: 3,
                    color: "white",
                    height: 48,
                  }}
                  onClick={handleSignOn}
                  disabled={loading}
                >
                  {loading ? "Signing In..." : "Single Sign-On"}
                </Button>
              </Grid>
              <Typography variant="body1" style={{ fontSize: "12px", color: "#6E7C87" }}>
                Note: Login using Single Sign-On if you are a Saint-Gobain User.
              </Typography>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default LoginLaunchPage;




//prod code
// const LoginLaunchPage = () => {
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const ApiURL = configParam.API_URL;
  

//   const containerStyle = {
//     position: 'relative',
//     right: '0',
//     top: '0',
//     height: "100vh",
//     width: '400px',
//     padding: '20px',
//     backgroundColor: "#fff", // Change this to your preferred background color
//   };



//   const onHandleSSO = () => {
//     const url = configParam.SSO_URL;
//     window.location.replace(url);
//   };


//   const userDetails_old = () => {
//     const url = window.location.href;
//     const Response = decodeURIComponent(url);
//     const myArray = Response.split("?");
//     log(Response)
//     if (myArray.length > 1) {
//       const queryParameters = new URLSearchParams(window.location.search)
//       console.log("queryParameters", queryParameters);
//       const UserDetails = queryParameters.get("UserData");
//       const access_token = queryParameters.get("access_token") 

//       const err = queryParameters.get("err");

//       const currentUserDetails = JSON.parse(UserDetails)


//       if (currentUserDetails && Object.keys(currentUserDetails).length > 0) {

//         localStorage.setItem("userDatas", JSON.stringify(currentUserDetails));

//         localStorage.setItem("accesstoken", access_token);

//         window.location.href = "/Plant";
//       } else {
//         localStorage.setItem("userDetails", "");
//         setError(err ?? "Access denied");
//         setLoading(false);
//       }
//     }
//   }

//   const fetchUserDetails = async (code) => {
//     try {

//       const response = await axios.get(`${ApiURL}/login`, {
//         params: {
//           code: code
//         }
//       });
   
//       console.log("response", response);
//       const { success, UserData, access_token, err } = response.data;
//       if (success) {
//         localStorage.setItem("userDatas", JSON.stringify(UserData));
//         localStorage.setItem('accesstoken', JSON.stringify(access_token));


//         window.location.href = "/Plant";
//       } else {
//         setError(err ?? "Access denied");
//         setLoading(false);
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       setError("An error occurred during login");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const queryParameters = new URLSearchParams(window.location.search);
//     const code = queryParameters.get("code");

//     if (code) {
//       fetchUserDetails(code);
//     } else {
//       setLoading(false);
//     }
//   }, []);

  
  // return (
  //   <div
  //     style={{
  //       display: "flex",
  //       width: "100%",
  //       flexDirection: window.innerWidth >= 600 ? "row" : "column",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       background:"white"
  //     }}
  //   >
  //     {/* Logo should appear only in desktop view (>=600px) */}
  //     {window.innerWidth >= 600 && (
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           flex: 1, // Takes half the width on desktop
  //         }}
  //       >
  //         <img src={LaunchLogo} alt="Logo" className="icon" />
  //       </div>
  //     )}
  
  //     <Grid
  //      container
  //            style={{ ...containerStyle }}
  //            justifyContent="center"
  //            alignItems="center"
       
  //     >
  //       <Grid
  //         item
  //         container
  //         direction="column"
  //         justifyContent="center"
  //         alignItems="start"
  //         sx={{
  //           width: { xs: "90%", sm: "70%", md: "50%" }, // Responsive width
  //         }}
  //       >
  //         {/* Smaller Logo inside Grid (keeps it for both mobile & desktop) */}
  //         <Grid item sx={{ alignSelf: "center", marginLeft: { xs: "25px", sm: "0px" } }}>
  //           <img src={LaunchLogo} alt="Logo" className="icon" style={{ width: "170px", height: "auto" }} />
  //         </Grid>
  
  //         <Grid item container direction="column" alignItems="center" sx={{ paddingLeft: { xs: "33px", sm: "0px" } }}>
  //           {error && (
  //             <Typography variant="subtitle1" style={{ color: "red", marginTop: "15px" }}>
  //               {error}&nbsp;
  //             </Typography>
  //           )}
  //           {!loading ? (
  //             <Button
  //               variant="contained"
  //               style={{
  //                 backgroundColor: "#0086DC",
  //                 width: "100%",
  //                 border: 0,
  //                 borderRadius: 3,
  //                 color: "white",
  //                 height: 48,
  //                 padding: "0 30px",
  //                 whiteSpace: "nowrap",
  //               }}
  //               onClick={onHandleSSO}
  //             >
  //               Single Sign-On
  //             </Button>
  //           ) : (
  //             <></>
  //           )}
  
  //           <Typography
  //             variant="body1"
  //             sx={{
  //               fontSize: "12px",
  //               width: "100%",
  //               color: "#6E7C87",
  //               textAlign: "left",
  //               margin: "16px 0",
  //               paddingLeft: { xs: "10px", sm: "0px" },
  //             }}
  //           >
  //             Note: Login using Single Sign-On if you are a Saint-Gobain User.
  //           </Typography>
  //         </Grid>
  
  //         <Grid
  //           item
  //           sx={{
  //             position: "absolute",
  //             left: 0,
  //             right: "0",
  //             bottom: "0",
  //             margin: "auto",
  //             textAlign: "center",
  //             paddingBottom: { xs: "10px", sm: "0px" },
  //           }}
  //         >
  //           <img src={sgLogo} alt="Logo" className="icon" />
  //           <Typography
  //             variant="body1"
  //             style={{
  //               marginTop: 8,
  //               fontSize: 12,
  //               textAlign: "center",
  //               marginBottom: "15px",
  //             }}
  //           >
  //             © 2024 INDEC4.0 Saint-Gobain
  //           </Typography>
  //         </Grid>
  //       </Grid>
  //     </Grid>
  //   </div>
  // );
  

  
// };

// export default LoginLaunchPage;

